import React from 'react';
import { styled } from '@linaria/react';

function Peg({
  distance,
  columnWidth,
}: {
  distance: number;
  columnWidth: number;
}) {
  return (
    <Wrapper style={{ left: distance * columnWidth }}>
      <LilPeg />
      {distance}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: absolute;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  text-align: center;
  transform: translate(calc(-50% - 1px), 100%);

  &:first-of-type {
    transform: translate(calc(-50% - 1.5px), 100%);
  }
`;

const LilPeg = styled.div`
  width: 3px;
  height: 10px;
  border-radius: 0px 0px 10px 10px;
  background: var(--color-text);
`;

export default Peg;
